"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var theme = require("./theme.module.scss");
var classcat_1 = require("classcat");
var TableContext_1 = require("./TableContext");
var utils_1 = require("./utils");
function Row(_a) {
    var className = _a.className, children = _a.children, index = _a.index, others = tslib_1.__rest(_a, ["className", "children", "index"]);
    var freezeColumnIndex = React.useContext(TableContext_1.default).freezeColumnIndex;
    var hasFreezedColumns = React.useMemo(function () { return utils_1.isNumber(freezeColumnIndex) && freezeColumnIndex > -1; }, [freezeColumnIndex]);
    var freezedColumns = [];
    var content = children;
    if (hasFreezedColumns) {
        freezedColumns = children.slice(0, freezeColumnIndex + 1);
        content = children.slice(freezeColumnIndex + 1);
    }
    return (React.createElement("div", tslib_1.__assign({ "data-row": true, "data-index": index }, others, { className: classcat_1.default([theme.row, className]) }),
        hasFreezedColumns && (React.createElement("div", { "data-sticky-columns-wrapper": true, className: theme.freezedColumnsWrapper }, freezedColumns)),
        React.createElement("div", { "data-columns-wrapper": true, className: theme.columnsWrapper }, content)));
}
exports.default = React.memo(Row);
